import get from 'lodash/get';
import "restangular";

export default class DevicesService {
  constructor($log, Restangular, $q, $http, $state) {
    'ngInject';
    this.$log = $log
    this.Restangular = Restangular
    this.$q = $q
    this.$http = $http
    this.$state = $state
    this.SERVICE_NAME = 'devices';
    this.uriBase = 'v1/devices';
  }

  adjustControlsMode(deviceId, controlsMode) {
    let payload = {
      controlsMode
    };

    let promise = this.Restangular.oneUrl(this.SERVICE_NAME,
      `${process.env.__backendUrl__}/internal/v1/devices/${deviceId}/controls-mode`).customPUT(payload);
    return promise;
  }

  getDeviceByMacAddress(macAddress) {
    let url = `${process.env.__backendUrl__}/internal/v1/devices?macAddress=${macAddress}`;
    return this.Restangular.oneUrl('internal/v1/devices', url).get();
  }

  getDeviceById(deviceId) {
    let url = `${process.env.__backendUrl__}/internal/v1/devices/${deviceId}`;
    let promise = this.Restangular.oneUrl(this.SERVICE_NAME, url).get();
    return promise;
  }

  sendUpdateCommandToPlayer(deviceId){
    let url = `${process.env.__backendUrl__}/internal/v1/devices/${deviceId}/commands/content-update`;
    return this.Restangular.oneUrl(this.SERVICE_NAME, url).post();
  }

  pairDevice(device, pairingCode){
    let json_body = {
      "pairingCode":pairingCode
    };
    return device.post('pair', json_body);
  }


  retriveFilteredDictionaryValue(dictionary, value) {
    let results = []
    for (let i = 0; i < dictionary.length; i++) {
      let each = dictionary[i];
      results.push(each[value]);
    }
    return results
  }

  executeSearchingPartialSerialByTenant(tenantId, partialSearch, unmanaged) {
    return this.searchDevicesByPartialSerialByTenant(tenantId, partialSearch, unmanaged)
      .then((res) => {
        let result = res["matches"];
        let isMac = false;
        let isGcmId = false;
        let isId = false;
        let serialDevicesDict = this.convertDevicesArrayToDictionaryObj(result, isId, isMac, isGcmId);
        let deviceSerialsOnly = this.retriveFilteredDictionaryValue(result, "serial");
        return [deviceSerialsOnly, serialDevicesDict];
      });
  }

  executeSearchingPartialSerialByDistributor(managingOrgId, partialSearch, unmanaged) {
    return this.searchDevicesByPartialSerial(managingOrgId, partialSearch, unmanaged)
      .then((res) => {
        let result = res["matches"];
        let isMac = false;
        let isGcmId = false;
        let isId = false;
        let serialDevicesDict = this.convertDevicesArrayToDictionaryObj(result, isId, isMac, isGcmId);
        let serialDevicesOnly = this.retriveFilteredDictionaryValue(result, "serial");
        return [serialDevicesOnly, serialDevicesDict];
      });
  }

  executeSearchingPartialSerialGlobally(partialSearch, unmanaged) {
    return this.searchDevicesByPartialSerialGlobally(partialSearch, unmanaged)
      .then((res) => {
        let result = res["matches"];
        let isMac = false;
        let isGcmId = false;
        let isId = false;
        let serialDevicesDict = this.convertDevicesArrayToDictionaryObj(result, isId, isMac, isGcmId);
        let serialDevicesOnly = this.retriveFilteredDictionaryValue(result, "serial");
        return [serialDevicesOnly, serialDevicesDict];
      });
  }

    executeSearchingPartialIdByTenant(tenantId, partialSearch, unmanaged) {
    return this.searchDevicesByPartialIdByTenant(tenantId, partialSearch, unmanaged)
      .then((res) => {
        let result = res["matches"];
        let isMac = false;
        let isGcmId = false;
        let isId = true;
        let devicesIdsDict = this.convertDevicesArrayToDictionaryObj(result, isId, isMac, isGcmId);
        let devicesIdsOnly = this.retriveFilteredDictionaryValue(result, "id");
        return [devicesIdsOnly, devicesIdsDict];
      });
  }

  executeSearchingPartialIdByDistributor(managingOrgId, partialSearch, unmanaged) {
    return this.searchDevicesByPartialId(managingOrgId, partialSearch, unmanaged)
      .then((res) => {
        let result = res["matches"];
        let isMac = false;
        let isGcmId = false;
        let isId = true;
        let devicesIdsDict = this.convertDevicesArrayToDictionaryObj(result, isId, isMac, isGcmId);
        let devicesIdsOnly = this.retriveFilteredDictionaryValue(result, "id");
        return [devicesIdsOnly, devicesIdsDict];
      });
  }

  executeSearchingPartialIdGlobally(partialSearch, unmanaged) {
    return this.searchDevicesByPartialIdGlobally(partialSearch, unmanaged)
      .then((res) => {
        let result = res["matches"];
        let isMac = false;
        let isGcmId = false;
        let isId = true;
        let devicesIdsDict = this.convertDevicesArrayToDictionaryObj(result, isId, isMac, isGcmId);
        let devicesIdsOnly = this.retriveFilteredDictionaryValue(result, "id");
        return [devicesIdsOnly, devicesIdsDict];
      });
  }

  executeSearchingPartialMacByTenant(tenantId, partialSearch, unmanaged) {
    return this.searchDevicesByPartialMacByTenant(tenantId, partialSearch, unmanaged)
      .then((res) => {
        let result = res["matches"];
        let isMac = true;
        let isGcmId = false;
        let isId = false;
        let macDevicesDict = this.convertDevicesArrayToDictionaryObj(result, isId, isMac, isGcmId);
        let deviceMacsOnly = this.retriveFilteredDictionaryValue(result, "mac");
        return [deviceMacsOnly, macDevicesDict];
      })
  }

  executeSearchingPartialMacByDistributor(managingOrgId, partialSearch, unmanaged) {
    return this.searchDevicesByPartialMac(managingOrgId, partialSearch, unmanaged)
      .then((res) => {
          let result = res["matches"];
          let isMac = true;
          let isGcmId = false;
          let isId = false;
          let macDevicesDict = this.convertDevicesArrayToDictionaryObj(result, isId, isMac, isGcmId);
          let macDevices = this.retriveFilteredDictionaryValue(result, "mac")
          return [macDevices, macDevicesDict];
        }
      );
  }

  executeSearchingPartialMacGlobally(partialSearch, unmanaged) {
    return this.searchDevicesByPartialMacGlobally(partialSearch, unmanaged)
      .then((res) => {
          let result = res["matches"];
          let isMac = true;
          let isGcmId = false;
          let isId = false;
          let macDevicesDict = this.convertDevicesArrayToDictionaryObj(result, isId, isMac, isGcmId);
          let macDevices = this.retriveFilteredDictionaryValue(result, "mac")
          return [macDevices, macDevicesDict];
        }
      );
  }

  executeSearchingPartialGCMidByTenant(tenantId, partialSearch, unmanaged) {
    return this.searchDistributorDevicesByPartialGCMidByTenant(tenantId, partialSearch, unmanaged)
      .then((res) => {
        let isMac = false;
        let isGcmId = true;
        let isId = false;
        let result = res["matches"];
        let gcmidDevicesDict = this.convertDevicesArrayToDictionaryObj(result, isId, isMac, isGcmId);
        let gcmidDevicesOnly = this.retriveFilteredDictionaryValue(result, "gcmid")
        return [gcmidDevicesOnly, gcmidDevicesDict];
      });
  }

  executeSearchingPartialGCMidByDistributor(managingOrgId, partialSearch, unmanaged) {
    return this.searchDistributorDevicesByPartialGCMid(managingOrgId, partialSearch, unmanaged)
      .then((res) => {
        let result = res["matches"];
        let isMac = false;
        let isGcmId = true;
        let isId = false;
        let GCMidDevicesDict = this.convertDevicesArrayToDictionaryObj(result, isId, isMac, isGcmId);
        let gcmidDevicesOnly = this.retriveFilteredDictionaryValue(result, "gcmid")
        return [gcmidDevicesOnly, GCMidDevicesDict];
      });
  }

  executeSearchingPartialGCMidGlobally(partialSearch, unmanaged) {
    return this.searchDistributorDevicesByPartialGCMidGlobally(partialSearch, unmanaged)
      .then((res) => {
        let result = res["matches"];
        let isMac = false;
        let isGcmId = true;
        let isId = false;
        let GCMidDevicesDict = this.convertDevicesArrayToDictionaryObj(result, isId, isMac, isGcmId);
        let gcmidDevicesOnly = this.retriveFilteredDictionaryValue(result, "gcmid")
        return [gcmidDevicesOnly, GCMidDevicesDict];
      });
  }

  rejectedPromise() {
    let deviceDeferred = this.$q.defer();
    deviceDeferred.reject()
    return deviceDeferred.promise
  };


  searchDevices(partialSearch, button, byTenant, tenantId, managingOrgId, unmanaged, globally) {
    let deferred = this.$q.defer();
    let devicesPromise;
    if (partialSearch) {
      if (partialSearch.length > 2) {
        if (button === "Serial Number") {
          if (globally) {
            devicesPromise = this.executeSearchingPartialSerialGlobally(partialSearch, unmanaged);
          } else if (byTenant) {
            devicesPromise = this.executeSearchingPartialSerialByTenant(tenantId, partialSearch, unmanaged)
          } else {
            devicesPromise = this.executeSearchingPartialSerialByDistributor(managingOrgId, partialSearch, unmanaged)
          }
        } else if (button === "Device Key"){
          if (globally) {
            devicesPromise = this.executeSearchingPartialIdGlobally(partialSearch, unmanaged);
          } else if (byTenant) {
            devicesPromise = this.executeSearchingPartialIdByTenant(tenantId, partialSearch, unmanaged)
          } else {
            devicesPromise = this.executeSearchingPartialIdByDistributor(managingOrgId, partialSearch, unmanaged)
          }
        } else if (button === "MAC") {
          if (globally) {
            devicesPromise = this.executeSearchingPartialMacGlobally(partialSearch, unmanaged);
          } else if (byTenant) {
            devicesPromise = this.executeSearchingPartialMacByTenant(tenantId, partialSearch, unmanaged)
          } else {
            devicesPromise = this.executeSearchingPartialMacByDistributor(managingOrgId, partialSearch, unmanaged)
          }
        } else {
          if (globally) {
            devicesPromise = this.executeSearchingPartialGCMidGlobally(partialSearch, unmanaged);
          } else if (byTenant) {
            devicesPromise = this.executeSearchingPartialGCMidByTenant(tenantId, partialSearch, unmanaged)
          } else {
            devicesPromise = this.executeSearchingPartialGCMidByDistributor(managingOrgId, partialSearch, unmanaged)
          }
        }
      } else {
        devicesPromise = this.rejectedPromise()
      }
    } else {
      devicesPromise = this.rejectedPromise()
    }

    devicesPromise.then(function (devicesResult) {
      deferred.resolve({
        "success": true,
        "devices": devicesResult
      })
    })

    devicesPromise.catch(function (devicesResult) {
      deferred.resolve({
        "success": false,
        "devices": []
      })
    })

    return deferred.promise
  }

  convertDevicesArrayToDictionaryObj(theArray, id, mac, gcm) {
    /** Converts array to dictionary with mac, gcmid, or serial as the key **/
    let devices = {};
    for (let i = 0; i < theArray.length; i++) {
      let item = theArray[i];
      if (mac) {
        devices[item.mac] = item;
      } else if (gcm) {
        devices[item.gcmid] = item;
      } else if (id) {
        devices[item.id] = item;
      } else {
        devices[item.serial] = item;
      }
    }
    return devices;
  };

  editItem(item, fromDevices) {
    if (!fromDevices) {
      fromDevices = false
    }
    this.$state.go('main.editDevice', {
      deviceId: item.id || item.key,
      tenantId: item.tenantId || item.tenant.id,
      fromDevices: fromDevices
    });
  }

  prepareForEditView(button, tenantId, searchText, macDevices, serialDevices, idDevices, gcmidDevices) {
    let mac, id, serial, gcmid;

    mac = button === "MAC";
    serial = button === "Serial Number";
    gcmid = button === "GCM ID";
    id = button === "Device Key";

    if (mac) {
      return this.editItem(macDevices[searchText]);
    } else if (serial) {
      return this.editItem(serialDevices[searchText]);
    } else if (id) {
      return this.editItem(idDevices[searchText]);
    } else {
      return this.editItem(gcmidDevices[searchText])
    }

  }

  getIssuesById(deviceId, startEpoch, endEpoch, page, limit) {
    let url = `${process.env.__backendUrl__}/internal/v1/devices/${deviceId}/issues?start=${startEpoch}&end=${endEpoch}&page=${page}&limit=${limit}`;
    let promise = this.Restangular.oneUrl(this.SERVICE_NAME, url).get();
    return promise;
  }

  getCommandEventsById(deviceId, page) {
    let url = `${process.env.__backendUrl__}/internal/v1/player-command-events/${deviceId}?page=${page}`;
    let promise = this.Restangular.oneUrl(this.SERVICE_NAME, url).get();
    return promise;
  }

  /////////////////////////////////////////////////////////////////////////
  // TENANT VIEW
  /////////////////////////////////////////////////////////////////////////
  getDevicesByTenant(tenantId, page) {
    if (tenantId !== undefined) {
      let url = this.makeDevicesByTenantURL(tenantId, page, false);
      return this.Restangular.oneUrl(this.SERVICE_NAME, url).get();
    }
  }

  getUnmanagedDevicesByTenant(tenantId, page) {
    if (tenantId !== undefined) {
      let url = this.makeDevicesByTenantURL(tenantId, page, true);
      return this.Restangular.oneUrl(this.SERVICE_NAME, url).get();
    }
  }

  searchDevicesByPartialSerialByTenant(tenantId, partialSerial, unmanaged) {
    if (tenantId !== undefined) {
      let url = `${process.env.__backendUrl__}/internal/v1/tenants/search/${tenantId}/devices?unmanaged=${unmanaged}&partialSerial=${partialSerial}`;
      let promise = this.Restangular.oneUrl(this.SERVICE_NAME, url).get();
      return promise;
    }
  }

  searchDevicesByPartialIdByTenant(tenantId, partialId, unmanaged) {
    if (tenantId !== undefined) {
      let url = `${process.env.__backendUrl__}/internal/v1/tenants/search/${tenantId}/devices?unmanaged=${unmanaged}&partialId=${partialId}`;
      let promise = this.Restangular.oneUrl(this.SERVICE_NAME, url).get();
      return promise;
    }
  }

  searchDevicesByPartialMacByTenant(tenantId, partialMac, unmanaged) {
    if (tenantId !== undefined) {
      let url = `${process.env.__backendUrl__}/internal/v1/tenants/search/${tenantId}/devices?unmanaged=${unmanaged}&partialMac=${partialMac}`;
      let promise = this.Restangular.oneUrl(this.SERVICE_NAME, url).get();
      return promise;
    }
  }

  searchDistributorDevicesByPartialGCMidByTenant(tenantId, partialGCMid, unmanaged) {
    if (tenantId !== undefined) {
      let url = `${process.env.__backendUrl__}/internal/v1/tenants/search/${tenantId}/devices?unmanaged=${unmanaged}&partialGCMid=${partialGCMid}`;
      let promise = this.Restangular.oneUrl(this.SERVICE_NAME, url).get();
      return promise;
    }
  }


  /////////////////////////////////////////////////////////////////////////
  // DEVICES VIEW
  /////////////////////////////////////////////////////////////////////////
  searchDevicesByPartialSerial(managingOrgId, partialSerial, unmanaged) {
    if (managingOrgId !== undefined) {
      let url =
        `${process.env.__backendUrl__}/internal/v1/managing_orgs/search/${managingOrgId}/devices?unmanaged=${unmanaged}&partialSerial=${partialSerial}`;
      let promise = this.Restangular.oneUrl(this.SERVICE_NAME, url).get();
      return promise;
    }
  }

  searchDevicesByPartialId(managingOrgId, partialId, unmanaged) {
    if (managingOrgId !== undefined) {
      let url =
        `${process.env.__backendUrl__}/internal/v1/managing_orgs/search/${managingOrgId}/devices?unmanaged=${unmanaged}&partialId=${partialId}`;
      let promise = this.Restangular.oneUrl(this.SERVICE_NAME, url).get();
      return promise;
    }
  }

  searchDevicesByPartialMac(managingOrgId, partialMac, unmanaged) {
    if (managingOrgId !== undefined) {
      let url =
        `${process.env.__backendUrl__}/internal/v1/managing_orgs/search/${managingOrgId}/devices?unmanaged=${unmanaged}&partialMac=${partialMac}`;
      let promise = this.Restangular.oneUrl(this.SERVICE_NAME, url).get();
      return promise;
    }
  }

  searchDistributorDevicesByPartialGCMid(managingOrgId, partialGCMid, unmanaged) {
    if (managingOrgId !== undefined) {
      let url =
        `${process.env.__backendUrl__}/internal/v1/managing_orgs/search/${managingOrgId}/devices?unmanaged=${unmanaged}&partialGCMid=${partialGCMid}`;
      let promise = this.Restangular.oneUrl(this.SERVICE_NAME, url).get();
      return promise;
    }
  }

  /////////////////////////////////////////////////////////////////////////
  // SEARCH DEVICES GLOBALLY
  /////////////////////////////////////////////////////////////////////////
  searchDevicesByPartialSerialGlobally(partialSerial, unmanaged) {
    let url = `${process.env.__backendUrl__}/internal/v1/devices/search/global?unmanaged=${unmanaged}&partialSerial=${partialSerial}`;
    let promise = this.Restangular.oneUrl("devices", url).get();
    return promise;

  }

   searchDevicesByPartialIdGlobally(partialId, unmanaged) {
    let url = `${process.env.__backendUrl__}/internal/v1/devices/search/global?unmanaged=${unmanaged}&partialId=${partialId}`;
    let promise = this.Restangular.oneUrl("devices", url).get();
    return promise;

  }

  searchDevicesByPartialMacGlobally(partialMac, unmanaged) {
    let url = `${process.env.__backendUrl__}/internal/v1/devices/search/global?unmanaged=${unmanaged}&partialMac=${partialMac}`;
    let promise = this.Restangular.oneUrl("devices", url).get();
    return promise;

  }

  searchDistributorDevicesByPartialGCMidGlobally(partialGCMid, unmanaged) {
    let url = `${process.env.__backendUrl__}/internal/v1/devices/search/global?unmanaged=${unmanaged}&partialGCMid=${partialGCMid}`;
    let promise = this.Restangular.oneUrl("devices", url).get();
    return promise;
  }


  /////////////////////////////////////////////////////////////////////////

  getDevicesByManagingOrg(managingOrgId, page) {
    if (managingOrgId !== undefined) {
      let url = this.makeDevicesByManagingOrgURL(managingOrgId, page, false);
      return this.Restangular.oneUrl(this.SERVICE_NAME, url).get();
    }
  }

  getUnmanagedDevicesByDistributor(managingOrgId, page) {
    if (managingOrgId !== undefined) {
      let url = this.makeDevicesByManagingOrgURL(managingOrgId, page, true);
      return this.Restangular.oneUrl(this.SERVICE_NAME, url).get();
    }
  }

  getDevices() {
    let promise = this.Restangular.all(this.SERVICE_NAME).getList();
    return promise;
  }

  save(device) {
    if (device.key !== undefined) {
      var promise = device.put();
    } else {
      var promise = this.Restangular.service('devices').post(device);
    }
    return promise;
  }

  saveOverlaySettings(device_id, bottomLeft, bottomRight, topRight, topLeft, overlaysAvailable) {
    let payload = {
      bottomLeft,
      bottomRight,
      topRight,
      topLeft,
      overlaysAvailable
    };

    return this.Restangular.oneUrl('overlay', `${process.env.__backendUrl__}/internal/v1/overlay/device/${device_id}`).customPOST(payload);
  }

  delete(device_id) {
    let promise = this.Restangular.oneUrl(this.SERVICE_NAME, `${process.env.__backendUrl__}/internal/v1/devices/${device_id}`).remove();
    return promise;
  }

  deprovision(device_id, reason) {
    let payload = {
      deprovisionReason: reason
    };
    let promise = this.Restangular.oneUrl(this.SERVICE_NAME, `${process.env.__backendUrl__}/internal/v1/devices/${device_id}/deprovision`).customPOST(payload);
    return promise;
  }

  getPanelModels() {
    return [
      {
        'id': 'None',
        'displayName': 'None'
      },
      {
        'id': 'Sony-FXD40LX2F',
        'displayName': 'Sony FXD40LX2F'
      },
      {
        'id': 'NEC-LCD4215',
        'displayName': 'NEC LCD4215'
      },
      {
        'id': 'Phillips-BDL5560EL',
        'displayName': 'Phillips BDL5560EL'
      },
      {
        'id': 'Panasonic-TH55LF6U',
        'displayName': 'Panasonic TH55LF6U'
      },
      {
        'id': 'LG-43SM5B-B',
        'displayName': 'LG 43SM5B-B'
      },
      {
        'id': 'Sharp-PNE521',
        'displayName': 'Sharp PNE521'
      },
      {
        'id': 'Samsung-HG55NE470SFXZA',
        'displayName': 'Samsung HG55NE470SFXZA'
      },
      {
        'id': 'LG-55LW340C',
        'displayName': 'LG 55LW340C'
      }
    ];
  }

  getPanelInputs() {
    return [
      {
        'id': 'None',
        'parentId': 'None'
      },
      {
        'id': 'HDMI1',
        'parentId': 'LG-43SM5B-B'
      },
      {
        'id': 'HDMI1',
        'parentId': 'Sony-FXD40LX2F'
      },
      {
        'id': 'HDMI2',
        'parentId': 'Sony-FXD40LX2F'
      },
      {
        'id': 'HDMI1',
        'parentId': 'Phillips-BDL5560EL'
      },
      {
        'id': 'HDMI2',
        'parentId': 'Phillips-BDL5560EL'
      },
      {
        'id': 'DVI',
        'parentId': 'Phillips-BDL5560EL'
      },
      {
        'id': 'HDMI1',
        'parentId': 'Panasonic-TH55LF6U'
      },
      {
        'id': 'HDMI2',
        'parentId': 'Panasonic-TH55LF6U'
      },
      {
        'id': 'DVI',
        'parentId': 'Panasonic-TH55LF6U'
      },
      {
        'id': 'HDMI1',
        'parentId': 'Sharp-PNE521'
      },
      {
        'id': 'HDMI2',
        'parentId': 'Sharp-PNE521'
      },
      {
        'id': 'DVI',
        'parentId': 'Sharp-PNE521'
      },
      {
        'id': 'VGA',
        'parentId': 'NEC-LCD4215'
      },
      {
        'id': 'DVI1',
        'parentId': 'NEC-LCD4215'
      },
      {
        'id': 'CATV',
        'parentId': 'Samsung-HG55NE470SFXZA'
      },
      {
        'id': 'HDMI1',
        'parentId': 'Samsung-HG55NE470SFXZA'
      },
      {
        'id': 'HDMI2',
        'parentId': 'Samsung-HG55NE470SFXZA'
      },
      {
        'id': 'DTV',
        'parentId': 'LG-55LW340C'
      },
      {
        'id': 'CADTV',
        'parentId': 'LG-55LW340C'
      },
      {
        'id': 'CATV',
        'parentId': 'LG-55LW340C'
      },
      {
        'id': 'AV',
        'parentId': 'LG-55LW340C'
      },
      {
        'id': 'COMPONENT',
        'parentId': 'LG-55LW340C'
      },
      {
        'id': 'RGBPC',
        'parentId': 'LG-55LW340C'
      },
      {
        'id': 'HDMI1',
        'parentId': 'LG-55LW340C'
      },
      {
        'id': 'HDMI2',
        'parentId': 'LG-55LW340C'
      }
    ];
  }

  makeDevicesByManagingOrgURL(managingOrgId, page, unmanaged) {
    let url =
      `${process.env.__backendUrl__}/internal/v1/managing_orgs/${managingOrgId}/devices?unmanaged=${unmanaged}&page=${page}`;
    return url
  }

  makeDevicesByTenantURL(tenantId, page, unmanaged) {
    let url = `${process.env.__backendUrl__}/internal/v1/tenants/${tenantId}/devices?unmanaged=${unmanaged}&page=${page}`;
    return url
  }

  getManagingOrgId(device) {
    return get(device, 'tenant.managingOrg');
  }

  isManagedDevice(device) {
    return get(device, 'isUnmanagedDevice') == false;
  }

  refreshViaCdm(device) {
    if (device) {
      return device.one('refresh-via-cdm').post();
    } else {
      return this.$q.reject();
    }
  }

  syncToContentManager(device) {
    if (device) {
      return device.one('sync-to-content-manager').post();
    } else {
      return this.$q.reject();
    }
  }
}
